import React from 'react';
import styled, { keyframes } from 'styled-components';

interface SpinnerProps {
  size?: string;
  color?: string;
  thickness?: string;
  speed?: string;
}

// Animação de rotação
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Componente estilizado do Spinner
const SpinnerContainer = styled.div<SpinnerProps>`
  width: ${(props) => props.size || '20px'};
  height: ${(props) => props.size || '20px'};
  border: ${(props) => props.thickness || '4px'} solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: ${(props) => props.color || '#1976d2'};
  animation: ${rotate} ${(props) => props.speed || '0.8s'} linear infinite;
  display: inline-block;
`;

const SpinnerWrapper = styled.div<{ fullScreen?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    props.fullScreen &&
    `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 9999;
  `}
`;

const Spinner: React.FC<SpinnerProps & { fullScreen?: boolean }> = ({
  size,
  color,
  thickness,
  speed,
  fullScreen,
}) => {
  return (
    <SpinnerWrapper fullScreen={fullScreen}>
      <SpinnerContainer size={size} color={color} thickness={thickness} speed={speed} />
    </SpinnerWrapper>
  );
};

export default Spinner;
